import React, { useState, useEffect } from "react";
import { FaClock, FaTimes } from "react-icons/fa";
import "./TempleStatusPopup.css";

const TempleStatusPopup = ({ templeStatus }) => {
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 7000);

    return () => clearTimeout(timer);
  }, []);

  if (!templeStatus?.status || !templeStatus?.upcoming || !showPopup) {
    return null;
  }

  const isOpen = templeStatus.status === "Open";

  return (
    <div className="temple-popup">
      <button
        className="close-popup"
        aria-label="Close popup"
        onClick={() => setShowPopup(false)}
      >
        <FaTimes />
      </button>

      <div className="temple-status">
        {/* Temple Status */}
        <div className="status-row">
          <span className="status-label">Temple Status</span>

          <span className={`status-pill ${isOpen ? "open" : "closed"}`}>
            <span className="status-dot"></span>
            {isOpen ? "Open" : "Closed"}
          </span>
        </div>

        {/* Aarti Information */}
        <div className="aarti-card">
          <FaClock className="clock-icon" />

          <div className="aarti-content">
            <span className="aarti-label">
              {isOpen ? "Current / Upcoming Aarti" : "Next Aarti"}
            </span>

            <div className="aarti-details">
              <strong>{templeStatus.upcoming.time}</strong>
              <span>•</span>
              <span>{templeStatus.upcoming.label}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const TempleStatusDisplay = ({ templeStatus }) => {
  if (!templeStatus?.status || !templeStatus?.upcoming) {
    return null;
  }

  const isOpen = templeStatus.status === "Open";

  return (
    <div style={{ marginBottom: "10px" }}>
      <p>
        Temple is:{" "}
        <span
          style={{
            color: isOpen ? "green" : "red",
            fontWeight: "bold",
          }}
        >
          {isOpen ? "🟢 Open" : "🔴 Closed"}
        </span>
      </p>

      <p>
        <FaClock style={{ marginRight: "5px" }} />
        {isOpen ? "Current/Upcoming Aarti: " : "Next Aarti: "}
        <strong>
          {templeStatus.upcoming.time} –{" "}
          {templeStatus.upcoming.label}
        </strong>
      </p>
    </div>
  );
};

export default TempleStatusPopup;